export default __webpack_public_path__ + "static/media/g-record-grey.1d78c345.svg";